import { faGear } from '@fortawesome/pro-solid-svg-icons';

import { useTranslate } from '@growtherapy/i18n';
import { IconButtonProps, Tooltip } from '@growtherapy/sprout-ui';

import { ControlPanelButton } from '../../components';
import { DrawerButton, DrawerButtonProps } from '../../components/DrawerButton';

export function SettingsDrawerControl({
  drawerId,
  forDrawerStates,
  isSettingsDrawerOpen,
  onClick,
}: {
  drawerId: string;
  forDrawerStates: DrawerButtonProps<IconButtonProps>['forDrawerStates'];
  isSettingsDrawerOpen: boolean;
  onClick: () => void;
}) {
  const t = useTranslate();
  const label = isSettingsDrawerOpen
    ? t('telehealth-core:controls.closeSettings')
    : t('telehealth-core:controls.openSettings');
  return (
    <div className='hidden md:block relative'>
      {/* NOTE: !w-max encourages the tooltip not to constrain its
          width to the child `DrawerButton`'s width. */}
      <Tooltip childIsInteractive text={label} className='!w-max'>
        <DrawerButton
          as={ControlPanelButton}
          forDrawerStates={forDrawerStates}
          className='hidden md:flex'
          aria-label={label}
          aria-expanded={isSettingsDrawerOpen}
          aria-controls={drawerId}
          iconDefinition={faGear}
          onClick={onClick}
        />
      </Tooltip>
    </div>
  );
}
